import { img, readdy } from '@/utils/images';

export interface SiteConfig {
  logoUrl: string;
  logoUrlDark: string;
  brandStats: { value: string; label: string }[];
  franchiseStats: { value: string; label: string }[];
  contactInfo: { company: string; brand: string; phone: string; email: string; address: string; workingHours: string };
  mapInfo: { address: string; phone: string; workingHours: string };
  consultationModal: { qrImage: string; phone: string; phoneLabel: string; hours: string; address: string };
  franchiseModal: { qrImage: string; phone: string; phoneLabel: string; hours: string; address: string };
  footerQrWechat: string;
  footerQrTiktok: string;
  corporateCulture: {
    mission: { title: string; description: string };
    vision: { title: string; description: string };
    values: { title: string; subtitle: string; desc: string }[];
  };
}

export const defaultSiteConfig: SiteConfig = {
  logoUrl: img('readdy/5977a8d6-be9c-4dde-b27f-e7ff6318fcfc_LOGO---.png'),
  logoUrlDark: img('readdy/95f54ddb-44ad-4177-bcb4-a8d3fd695ca5_LOGO--.png'),
  brandStats: [
    { value: '12+', label: '余年行业积淀' },
    { value: '17+', label: '城市市场覆盖' },
    { value: '200+', label: '品牌合作门店' },
    { value: '38万+', label: '累计服务顾客' },
  ],
  franchiseStats: [
    { value: '13+', label: '年行业积淀' },
    { value: '17+', label: '城市覆盖' },
    { value: '98%', label: '加盟商续签率' },
  ],
  contactInfo: {
    company: '麦杰集团',
    brand: '颜轻至',
    phone: '400-888-6688',
    email: 'contact@yanqingzhi.com',
    address: '陕西省西安市雁塔区科技路XX号',
    workingHours: '周一至周日 09:00 - 21:00',
  },
  mapInfo: {
    address: '西安市未央区未央路武警小区南楼（恒佳首座东）',
    phone: '400-888-6688',
    workingHours: '周一至周日 09:00 - 21:00',
  },
  consultationModal: {
    qrImage: readdy('consult-qr-2026v1'),
    phone: '177 9288 3069  李女士',
    phoneLabel: '客服热线',
    hours: '周一至周日 09:00 - 21:00',
    address: '西安市未央区未央路武警小区南楼（恒佳首座东）',
  },
  franchiseModal: {
    qrImage: readdy('franch-qr-2026v1'),
    phone: '153 5367 5777',
    phoneLabel: '招商热线',
    hours: '周一至周五 09:00 - 18:00',
    address: '西安市未央区未央路武警小区南楼（恒佳首座东）',
  },
  footerQrWechat: readdy('wechat-qr-2026v1'),
  footerQrTiktok: readdy('tiktok-qr-2026v1'),
  corporateCulture: {
    mission: {
      title: '使命',
      description: '追求全体"颜轻至人"物质和精神两方面幸福的同时，帮助更多人塑造轻盈的体态、活力的生命和自信的人生，为健康中国的宏伟蓝图贡献伟大力量。',
    },
    vision: {
      title: '愿景',
      description: '通过线下门店+大健康数据平台的方式打造健康生态，将"颜轻至"打造成全球体重管理与健康生活领域的绝对第一品牌。',
    },
    values: [
      {
        title: '敬业爱岗',
        subtitle: '忠诚专业的职业素养',
        desc: '以赤诚之心对待每一份工作，以专业精神服务每一位顾客。把岗位当舞台，把工作当事业，在平凡中追求卓越。',
      },
      {
        title: '开拓创新',
        subtitle: '独立自主的创新胆略',
        desc: '敢于突破思维边界，勇于探索未知领域。以独立自主的姿态持续推动产品、服务、模式的全方位创新升级。',
      },
      {
        title: '乐于吃苦',
        subtitle: '不惧艰难的乐观主义',
        desc: '以乐观的心态面对挑战，以坚韧的意志跨越困难。在逆境中磨砺成长，用笑容迎接每一次蜕变与新生。',
      },
      {
        title: '善于团结',
        subtitle: '顾全大局的集体主义',
        desc: '心往一处想，劲往一处使。以集体利益为重，以团队协作为荣，凝聚每一份力量共创品牌辉煌。',
      },
    ],
  },
};